import React, { Fragment } from 'react'
import SiteHeader from '../../../components/SiteHeader';
import { Link } from 'react-router-dom'
import Breadcumb from '../../../components/Breadcumb'
import ServiceArea from '../../../components/ServiceArea'
import Testimonials from '../../../components/Testimonials'
import CallToAction from '../../../components/CallToAction'
import FaqSection from '../../../components/FaqSection'
import FooterArea from '../../../components/FooterArea'
import Seo from '../../../components/Seo'
import { breadcrumbSchema, serviceSchema, faqSchema } from '../../../seo/config'
import { PRACTICE_AREAS } from '../../../data/practiceAreas'
// images
import breadcumb from '../../../images/breadcumb/about-practice.jpg'
import divorce from '../../../images/services/divorce.jpg'
import checkBounce from '../../../images/services/check-bounce.png'
import dispute from '../../../images/services/dispute.jpeg'
import criminal from '../../../images/services/criminal.jpg'
import contract from '../../../images/services/contract.jpg'
import property from '../../../images/services/property.jpg'

import './style.scss'

const services = [
    {
        img: divorce,
        icon: 'flaticon-parents',
        title: 'Divorce & Family Law',
        content: 'Expert handling of marriage, child custody, maintenance, domestic violence, and divorce cases with compassion and efficiency.'
    },
    {
        img: property,
        icon: 'flaticon-house',
        title: 'Property & Real Estate',
        content: 'Comprehensive legal services for property transactions, RERA matters, and real estate disputes across Delhi NCR.'
    },
    {
        img: checkBounce,
        icon: 'flaticon-wounded',
        title: 'Recovery & Cheque Bounce',
        content: 'Strategic legal action for money recovery and cheque bounce cases with proven success rates.'
    },
    {
        img: criminal,
        icon: 'flaticon-thief',
        title: 'Criminal Law',
        content: 'Expert criminal defense across all courts with a track record of securing favorable outcomes.'
    },
    {
        img: dispute,
        icon: 'flaticon-employee',
        title: 'Corporate & Commercial',
        content: 'Representing businesses in complex commercial disputes and corporate litigation matters.'
    },
    {
        img: contract,
        icon: 'flaticon-university-graduate-hat',
        title: 'Contract & Documentation',
        content: 'Professional contract drafting, review, and legal documentation services for businesses.'
    }
]

const breadcumbMenu = [
    { name: 'Home', route: '/' },
    { name: 'Practice Areas' }
]

const practiceFaqs = PRACTICE_AREAS.map((a) => a.faqs[0]).filter(Boolean)

const PracticePage = () => {
    return (
        <Fragment>
            <Seo
                title="Practice Areas — Divorce, Property, Criminal & Corporate Law"
                description="Explore Legal Corridor's practice areas in Delhi NCR: divorce & family law, property & RERA, cheque bounce recovery, criminal defence, and corporate & contract law."
                path="/practice"
                schema={[
                    breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Practice Areas', path: '/practice' }]),
                    ...PRACTICE_AREAS.map((a) =>
                        serviceSchema({ name: a.name, description: a.metaDescription, path: `/practice/${a.slug}`, serviceType: a.name })
                    ),
                    faqSchema(practiceFaqs),
                ]}
            />
            <SiteHeader />
            <main>
            <Breadcumb
                className="breadcumbArea"
                title="Our Practice Areas"
                breadcumbMenu={breadcumbMenu}
                background={breadcumb}
            />

            {/* Introduction */}
            <section className="practiceIntroSection">
                <div className="container">
                    <div className="sectionTitle">
                        <span>Areas of Expertise</span>
                        <h2>Comprehensive Legal Services</h2>
                        <p>We offer a broad range of legal services across multiple practice areas, ensuring expert representation for all your legal needs.</p>
                    </div>
                </div>
            </section>

            <ServiceArea
                className="ourServiceArea ourServiceAreaStyleThree bgFFF"
                title="Our Practice Areas"
                subTitle="Expert Legal Solutions"
                services={services}
            />

            {/* Internal links to dedicated practice-area landing pages */}
            <section className="practiceLinksSection">
                <div className="container">
                    <div className="sectionTitle">
                        <span>Explore in Detail</span>
                        <h2>Dedicated Practice Areas</h2>
                    </div>
                    <div className="practiceLinksGrid">
                        {PRACTICE_AREAS.map((a) => (
                            <Link key={a.slug} to={`/practice/${a.slug}`} className="practiceLinkCard">
                                <h3>{a.name}</h3>
                                <p>{a.metaDescription}</p>
                                <span className="practiceLinkMore">Learn more →</span>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            <FaqSection title="Legal Services — FAQs" subTitle="Your Questions, Answered" faqs={practiceFaqs} />

            <Testimonials />

            <CallToAction />
            </main>
            <FooterArea />
        </Fragment>
    )
}
export default PracticePage